import { Dispatch, SetStateAction } from "react";
import Link from "next/link";
import { useUser } from "../../utils/AuthContext";
import { motion } from "framer-motion";
import { useRouter } from "next/router";

type Props = {
  user: any;
  tab: number;
  setTab: Dispatch<SetStateAction<number>>;
};

const links = [
  { title: "Playground", icon: "smart_toy" },
  { title: "VBA", icon: "code" },
  { title: "Task AI", icon: "headset_mic" },
  { title: "Archives", icon: "archive" },
  { title: "Help", icon: "help" },
  { title: "Billing", icon: "account_circle" },
];

const LeftPanel = ({ user, tab, setTab }: Props) => {
  const { logOut } = useUser();

  const router = useRouter();

  return (
    <div className="drawer w-60 border-r-2">
      <div className="drawer-side">
        <ul className="flex flex-col justify-between h-full">
          <div className="mt-8 flex flex-col gap-4 items-center">
            {links.map((link, i) => (
              <li
                key={i}
                onClick={() => {
                  setTab(i);
                  router.push('/dashboard?tabQueryParam=' + i);
                }}
                className="relative w-52 min-h-12 px-4 cursor-pointer"
              >
                <a className={`w-52 rounded-xl flex gap-4 items-center`}>
                  <span className="material-icons">{link.icon}</span>
                  {link.title}
                  {link.title === "Task AI" && (
                    <span className="bg-orange-200 font-semibold px-2 text-sm rounded-full">
                      new
                    </span>
                  )}
                </a>

                {tab === i && (
                  <motion.div
                    className="bg-green-200 w-52 h-12 rounded-xl absolute -top-3 left-0 -z-10"
                    layoutId="bg"
                  ></motion.div>
                )}
              </li>
            ))}
          </div>

          <div className="mb-4 flex flex-col gap-4 items-center">
            {user && (
              <>
                <li className="w-52 min-h-12 px-4 cursor-pointer">
                  <Link href={"/"}>
                    <a className={"w-52 rounded-xl flex gap-4 items-center"}>
                      <span className="material-icons">home</span>
                      Home
                    </a>
                  </Link>
                </li>
                <li className="w-52 min-h-12 cursor-pointer">
                  <a
                    className={
                      "bg-gray-300 p-4 rounded-xl flex gap-4 items-center"
                    }
                    onClick={() => logOut()}
                  >
                    <span className="material-icons">logout</span>
                    Logout
                  </a>
                </li>
              </>
            )}
          </div>
        </ul>
      </div>
    </div>
  );
};

export default LeftPanel;
